import React from 'react';

import { Button, Divider, Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { IItem } from '@rbi-ctg/menu';
import { DebugToolModal, StoreInfo } from 'components/debug-tool';
import { Box, Typography } from 'components/ui';
import { MenuObjectTypes } from 'enums/menu';
import useFoodware from 'hooks/use-foodware';

import { SelectedItemDebug } from '../components/selected-item-debug';

const FoodwareDebugModal: React.FC<{
  onClose: () => void;
}> = ({ onClose }) => {
  const { featureFoodware } = useFoodware();

  return (
    <DebugToolModal onOpenEventMessage="Menu Debug Tool: Foodware" onClose={onClose}>
      <Box style={styles.container}>
        <StoreInfo />
        <Divider marginBottom="$6" />
        <Typography variant="headerOne">Selected Product:</Typography>
        {featureFoodware?.items ? (
          featureFoodware.items.map(foodware => {
            const { name, _id } = foodware || {};
            if (name && _id) {
              return (
                <React.Fragment key={_id}>
                  <SelectedItemDebug
                    selectedItemVendorConfig={foodware as IItem}
                    productName={name.locale ?? ''}
                    selectedItemType={MenuObjectTypes.ITEM}
                    oneMenuEntryId={_id}
                    hideTitle
                    hidePosVendor
                  />
                  <Divider />
                </React.Fragment>
              );
            }
            return (
              <Typography variant="headerTwo" key={_id}>
                Error: Encountered null or missing properties when parsing foodware
              </Typography>
            );
          })
        ) : (
          <Typography variant="headerTwo">No foodware items found.</Typography>
        )}
      </Box>
    </DebugToolModal>
  );
};

const styles = StyleSheet.create({
  container: { marginVertical: 16 },
});

export const FoodwareDebug = () => {
  const [isDebugMenuModalOpen, setIsDebugMenuModalOpen] = React.useState(false);

  return (
    <>
      <Button
        variant="ghost"
        onPress={() => setIsDebugMenuModalOpen(true)}
        leftIcon={<Icon name="mi:bug-report" />}
      >
        <Typography>View Foodware info</Typography>
      </Button>

      {isDebugMenuModalOpen && (
        <FoodwareDebugModal onClose={() => setIsDebugMenuModalOpen(false)} />
      )}
    </>
  );
};
